import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MoralisProvider } from 'react-moralis';

import Home from './pages/home/Home';
/******* START: Import Local Files *******/
import './index.css';
import App from './pages/App';
import Swap from "./pages/swap/Swap"
import SwapGraph from "./pages/SwapGraph/SwapGraph"

import Liquidity from "./pages/liquidity/Liquidity"
import LiquidityGraph from "./pages/LiqGraph/LiquidityGraph"

import Dashboard from './components/analytics/Dashboard/Dashboard';

import PositionDetails from './pages/PositionDetails/PositionDetails';
import Analyticsv2 from './pages/analyticsv2/Analyticsv2';
import TestPage1 from './pages/TestPage1/TestPage1';
import Reposition from './pages/Reposition/Reposition';
/******* End: Import React and Dongles *******/

const serverUrl = "https://lyxa4rgzfkuo.usemoralis.com:2053/server";
const appId = "YBftd2ewCPD1j6DcP2zTrVwBoj9gXhZbBcujioRA";




ReactDOM.render(
  <React.StrictMode>
    <MoralisProvider appId={appId} serverUrl={serverUrl}>

    <BrowserRouter>
        <Routes>
        <Route path='/' element={<App />}>
        <Route index element={<Home />} />
        <Route path='swap' element={<Swap />}/>
        <Route path='swapgraph' element={<SwapGraph />}/>
        <Route path='liquidity' element={<Liquidity />}/>
        <Route path='liquiditygraph' element={<LiquidityGraph />}/>
        <Route path='analytics' element={<Dashboard />}/>
            <Route path='position/details/:posHash' element={<PositionDetails />} />
            <Route path="position/reposition/:posHash" element={<Reposition />} />
        <Route path='analyticsv2' element={<Analyticsv2 />}/>
        <Route path='testpage' element={<TestPage1 />}/>
                  
                </Route>
              </Routes>
            </BrowserRouter>
    </MoralisProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
